var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "220px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "min-width": "180px",
                    width: "100%",
                    height: "100%",
                    padding: "10px 0px 10px"
                  }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "min-height": "500px",
                      "padding-left": "16px"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c("cargo-button-group-slider", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "look",
                                expression: "action==='look'"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.goBack }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.editHandler("edit")
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("Payment.edit2")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: _vm.isEditing,
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.copyJobHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.btn.acceptRole && !_vm.isCooperate,
                                    expression: "btn.acceptRole && !isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.job.uuid &&
                                    _vm.currentRow.preverifyState !== 5 &&
                                      _vm.currentRow.preverifyState !== 2 &&
                                      _vm.currentRow.preverifyState !== 3
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.acceptHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.btn.rejectRole && !_vm.isCooperate,
                                    expression: "btn.rejectRole && !isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.jobState === -1 &&
                                    !_vm.isEditing &&
                                    _vm.job.uuid &&
                                    _vm.currentRow.preverifyState !== 5 &&
                                      _vm.currentRow.preverifyState !== 2 &&
                                      _vm.currentRow.preverifyState !== 3
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.rejectHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.btn.acceptRole && _vm.isCooperate,
                                    expression: "btn.acceptRole && isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    !_vm.isEditing &&
                                    _vm.job.uuid &&
                                    [
                                      _vm.SystemConstants
                                        .COOPERATE_STATUS_PENDING.code
                                    ].includes(_vm.currentRow.cooperateStatus)
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.acceptCooperateHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.btn.rejectRole && _vm.isCooperate,
                                    expression: "btn.rejectRole && isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    !_vm.isEditing &&
                                    _vm.job.uuid &&
                                    [
                                      _vm.SystemConstants
                                        .COOPERATE_STATUS_PENDING.code
                                    ].includes(_vm.currentRow.cooperateStatus)
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.rejectHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.onPrint }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.btn.reviewThrough &&
                                      _vm.btn.pretrialReviewConfig &&
                                      !_vm.isCooperate,
                                    expression:
                                      "btn.reviewThrough && btn.pretrialReviewConfig && !isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.preverifyState === 2
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.btVerifyReviewThroughHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.VerifyReviewThrough")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.btn.reviewRefusal &&
                                      _vm.btn.pretrialReviewConfig &&
                                      !_vm.isCooperate,
                                    expression:
                                      "btn.reviewRefusal && btn.pretrialReviewConfig && !isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !(
                                    _vm.currentRow &&
                                    _vm.currentRow.preverifyState === 2
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.btVerifyReviewRefusalHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.VerifyReviewRefusal")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isNew,
                                expression: "isNew"
                              }
                            ],
                            staticClass: "new",
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.save }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit(_vm.goBack)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "SaveTheDefaultValues",
                                  type: "primary"
                                },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "edit",
                                expression: "action==='edit'"
                              }
                            ],
                            staticClass: "btn-group-edit",
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: { click: _vm.save }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit(_vm.lookHandler)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "SaveTheDefaultValues2",
                                  type: "primary"
                                },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.action === "look" || _vm.action === "edit",
                              expression: "action==='look'||action==='edit'"
                            }
                          ],
                          staticStyle: {
                            display: "flex",
                            "white-space": "nowrap"
                          }
                        },
                        [
                          _c("CargoIm", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.imCacheKey && _vm.action === "look",
                                expression: "imCacheKey && action==='look'"
                              }
                            ],
                            ref: "cargoIm"
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  _vm.action === "edit"
                                    ? ""
                                    : _vm.$t("SeaExport.Tip1"),
                                placement: "bottom-start",
                                offset: _vm.sopTooltipOffset,
                                "visible-arrow": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    cursor: "pointer"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red",
                                      staticStyle: {
                                        "font-size": "14px",
                                        padding: "5px 0"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.commonInfo.jobState))]
                                  ),
                                  _c("span", {
                                    staticStyle: {
                                      padding: "5px 9px",
                                      color: "unset"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red",
                                      staticStyle: { padding: "5px 0" }
                                    },
                                    [_vm._v(_vm._s(_vm.commonInfo.jobLock))]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      !_vm.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "basicTab",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-general-UICustom", {
                                    ref: "basicTab",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "page-source": "AeBookingVerify",
                                      "view-source": "bookingWorkspace"
                                    }
                                  })
                                : _c("tab-general", {
                                    ref: "basicTab",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "page-source": "AeBookingVerify"
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "masterBasicTab",
                                label: _vm.$t("SeaExport.Basic")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-master-UICustom", {
                                    ref: "masterBasicTab",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sea-export": true,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "bookingWorkspace"
                                    },
                                    on: {
                                      selectJob: function(jobUuid) {
                                        _vm.transferTargetRow("edit", jobUuid)
                                      },
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster
                                    }
                                  })
                                : _c("tab-master", {
                                    ref: "masterBasicTab",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "is-sea-export": true,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "view-source": "bookingWorkspace"
                                    },
                                    on: {
                                      selectJob: function(jobUuid) {
                                        _vm.transferTargetRow("edit", jobUuid)
                                      },
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: 13,
                          attrs: {
                            lazy: true,
                            name: "tabCharges",
                            label: _vm.$t("SeaExport.Charge")
                          }
                        },
                        [
                          _c("tab-charges", {
                            ref: "tabCharges",
                            attrs: {
                              context: _vm.context,
                              action: _vm.action,
                              "view-source": "AeBookingVerify"
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.isNew &&
                      _vm.privilege.chargeConfirm.chargeConfirmView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 22,
                              attrs: {
                                lazy: true,
                                name: "tabInternalBill",
                                label: _vm.$t("SeaExport.InternalBillInfo")
                              }
                            },
                            [
                              _c("tab-internal-bill", {
                                ref: "tabInternalBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew && _vm.privilege.billTab.billTabView
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 23,
                              attrs: {
                                lazy: true,
                                name: "tabOverseaBill",
                                label: _vm.$t("SeaExport.OverseaBillInfo")
                              }
                            },
                            [
                              _c("tab-oversea-bill", {
                                ref: "tabOverseaBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "AeBookingVerify"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: 19,
                          attrs: {
                            lazy: true,
                            name: "tabFileHistory",
                            label: _vm.$t("SeaExport.FileHistory")
                          }
                        },
                        [
                          _c("tab-file-history", {
                            ref: "tabFileHistory",
                            attrs: {
                              context: _vm.context,
                              "cooperate-edit": _vm.cooperateEditOther
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.acceptDialog.visible
        ? _c("accept-dialog", {
            attrs: {
              visible: _vm.acceptDialog.visible,
              "job-model": _vm.acceptDialog.job || {},
              "batch-pass-audit": _vm.acceptDialog.batchPassAudit,
              "submit-call-back": _vm.acceptDialog.submitCallBack,
              "job-list": _vm.acceptDialog.jobList || []
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.acceptDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.rejectWindow.visible
        ? _c("reject-dialog", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("department-chooser-dialog", {
        attrs: {
          visible: _vm.departmentChooserDialog.visible,
          departments: _vm.departmentChooserDialog.departments,
          "show-cancel-btn": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.departmentChooserDialog, "visible", $event)
          },
          callback: _vm.departmentChooserDialogCallback
        }
      }),
      _vm.confirmDialogWindow.visible
        ? _c("confirm-dialog-window", {
            attrs: {
              visible: _vm.confirmDialogWindow.visible,
              "message-title": _vm.confirmDialogWindow.messageTitle,
              content: _vm.confirmDialogWindow.content,
              "show-confirm-btn": _vm.confirmDialogWindow.showConfirmBtn,
              "confirm-call-back": _vm.confirmDialogWindow.confirmCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.confirmDialogWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("estimate-validation-dialog", {
        ref: "estimateValidationDialog",
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.cooperationVerifyDialog.visible
        ? _c("cooperation-verify-dialog", {
            attrs: {
              visible: _vm.cooperationVerifyDialog.visible,
              "job-uuid": _vm.cooperationVerifyDialog.jobUuid,
              cooperate: _vm.cooperationVerifyDialog.cooperate,
              "submit-call-back": _vm.cooperationVerifyDialog.submitCallBack,
              editable: _vm.cooperationVerifyDialog.editable
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationVerifyDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2,
              "new-job": _vm.batchCheckingWindow.newJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2,
              "new-job": _vm.checkingWindow.newJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }